import { Box, Grid, Modal, Paper, Typography } from '@mui/material'
import { MouseEvent } from 'react'
import type { KeyModalProps } from '../types'
import { AvatarPlayer } from '../../common'

export const KeyModal = (props: KeyModalProps) => {
    const {
        title,
        children,
        handleClose,
        videoName,
        isPortable,
        shouldPlay,
        ...elementProps
    } = props

    return (
        <Modal
            onClick={handleClose}
            className='key-modal'
            {...elementProps}
        >
            <Box
                sx={{
                    position: 'absolute' as 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    minHeight: '32.5rem',
                    width: '90%',
                    maxWidth: '77.5rem',
                    maxHeight: '80%',
                    overflowY: 'auto',
                    borderRadius: '6px',
                }}
                onClick={(e: MouseEvent) => e.stopPropagation()}
            >
                <Paper className='bg-pantone-white-90 p-4 md:p-14'>
                    <Grid
                        container
                        spacing={3}
                        direction={{ xs: 'column', md: 'row' }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={8}
                        >
                            {title && (
                                <Typography className='text-pantone-gray-2 pb-4 md:pb-12 font-semibold text-2xl md:text-4xl'>
                                    {title}
                                </Typography>
                            )}
                            {isPortable && elementProps.open && (
                                <AvatarPlayer
                                    className='lg:hidden w-full'
                                    videoName={videoName}
                                    shouldPlay={shouldPlay}
                                />
                            )}
                            <Box className='pr-0 md:pr-14 lg:pr-28'>
                                {children}
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            className='hidden lg:block'
                        >
                            {!isPortable && elementProps.open && (
                                <AvatarPlayer
                                    shouldPlay={shouldPlay}
                                    videoName={videoName}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Modal>
    )
}
